import { jsxs, jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { usePageProps, FaqStructuredData, FAQ, getCmsInfoForPage } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import { extractFaqItems } from "./extractFaqItems.esm.js";
const BlockFAQ = ({
  innerBlocks,
  attrs: {
    id,
    allExpanded,
    collapseOthers
  }
}) => {
  const pageProps = usePageProps();
  const [expandedPanelIndices, setExpandedPanelIndices] = React.useState(() => {
    const expandedIndices = [];
    innerBlocks.forEach((item, index) => {
      if (item.attrs.expanded || allExpanded) {
        expandedIndices.push(index);
      }
    });
    if (collapseOthers && expandedIndices.length > 1) {
      expandedIndices.length = 1;
    }
    return expandedIndices;
  });
  const onSelectPanel = (index, nextState) => {
    var _a, _b, _c, _d;
    if (nextState.includes(index)) {
      event({
        // https://dataportal.zillowgroup.net/event-registry/5030
        envelope: {
          event_type_id: "5030",
          event_type_version_id: "1",
          event_template_id: "297",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_faq",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_open"
        },
        cms_info: {
          block_id: ((_b = (_a = innerBlocks[index]) == null ? void 0 : _a.attrs) == null ? void 0 : _b.id) || "",
          block_type_cd: "faq_item",
          ...getCmsInfoForPage(pageProps)
        }
      });
    } else {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2051
        envelope: {
          event_type_id: "2051",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_faq",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_close"
        },
        cms_info: {
          block_id: ((_d = (_c = innerBlocks[index]) == null ? void 0 : _c.attrs) == null ? void 0 : _d.id) || "",
          block_type_cd: "faq_item",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }
    if (collapseOthers) {
      setExpandedPanelIndices(nextState.includes(index) ? [index] : []);
    } else {
      setExpandedPanelIndices(nextState);
    }
  };
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(FaqStructuredData, { faq: extractFaqItems(innerBlocks) }),
    /* @__PURE__ */ jsx(FAQ, { forwardedAs: "dl", id, expanded: expandedPanelIndices, onChange: onSelectPanel, children: generateBlockList({
      blocks: innerBlocks
    }) })
  ] });
};
BlockFAQ.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    allExpanded: PropTypes.bool
  }).isRequired,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    attrs: PropTypes.shape({
      expanded: PropTypes.bool
    })
  })).isRequired
};
export {
  BlockFAQ as default
};
